import { formatAmountInput, parseAmount } from "./format.js";
export function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

/** Abre un modal y devuelve el nodo raíz; `onClose` se dispara al cerrarlo. */
export function openModal(html, { onClose } = {}) {
  const overlay = document.createElement("div");
  overlay.className = "modal-overlay";
  overlay.innerHTML = `<div class="modal">${html}</div>`;

  // En teléfono, sin esto el fondo scrollea detrás del modal y se pierde
  // la posición de la lista al cerrarlo.
  const previousOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";

  const close = () => {
    overlay.remove();
    document.body.style.overflow = previousOverflow;
    document.removeEventListener("keydown", onKeydown);
    onClose?.();
  };
  const onKeydown = (e) => {
    if (e.key === "Escape") close();
  };

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener("keydown", onKeydown);
  document.body.appendChild(overlay);

  overlay.close = close;
  return overlay;
}

export function confirmDialog(message) {
  return window.confirm(message);
}

export function showError(container, error) {
  const message = error?.message || String(error);
  container.innerHTML = `<div class="panel"><p class="error-text">Error: ${escapeHtml(message)}</p></div>`;
}

/**
 * Campos de importe con formato argentino.
 *
 * Van como <input type="text" inputmode="decimal" data-amount>, no como
 * type="number": los campos numéricos del navegador rechazan el punto de miles
 * o lo interpretan como decimal, así que "250.000" terminaba guardado como 250.
 * Acá se acepta lo que la persona escriba y se le da formato al salir del campo.
 */
export function formatAmountsIn(root) {
  root.querySelectorAll("[data-amount]").forEach((el) => {
    if (el.value.trim() !== "") el.value = formatAmountInput(parseAmount(el.value));
  });
}

export function wireAmountInputs(root) {
  formatAmountsIn(root);
  // Delegado, para que las filas que se agregan después también queden atendidas.
  root.addEventListener("focusout", (e) => {
    if (e.target?.matches?.("[data-amount]") && e.target.value.trim() !== "") {
      e.target.value = formatAmountInput(parseAmount(e.target.value));
    }
  });
}
